var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Cup/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 3.33333H5.33334C4.96515 3.33333 4.66668 3.63181 4.66668 4V6.66667C4.66668 8.50762 6.15906 10 8.00001 10C9.84096 10 11.3333 8.50762 11.3333 6.66667V4C11.3333 3.63181 11.0349 3.33333 10.6667 3.33333ZM5.33334 2C4.22877 2 3.33334 2.89543 3.33334 4V6.66667C3.33334 9.244 5.42268 11.3333 8.00001 11.3333C10.5773 11.3333 12.6667 9.244 12.6667 6.66667V4C12.6667 2.89543 11.7712 2 10.6667 2H5.33334Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666656 5.33325C0.666656 4.22868 1.56209 3.33325 2.66666 3.33325H4.66666V8.66659H3.33332C1.86056 8.66659 0.666656 7.47268 0.666656 5.99992V5.33325ZM2.66666 4.66659H3.33332V7.33325C2.59694 7.33325 1.99999 6.7363 1.99999 5.99992V5.33325C1.99999 4.96506 2.29847 4.66659 2.66666 4.66659Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3333 5.33325C15.3333 4.22868 14.4379 3.33325 13.3333 3.33325H11.3333V8.66659H12.6667C14.1394 8.66659 15.3333 7.47268 15.3333 5.99992V5.33325ZM13.3333 4.66659H12.6667V7.33325C13.403 7.33325 14 6.7363 14 5.99992V5.33325C14 4.96506 13.7015 4.66659 13.3333 4.66659Z",
    fill: "#777E91"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M8.00001 10C7.63182 10 7.33334 10.2985 7.33334 10.6667V12.6667H6.00001C5.63182 12.6667 5.33334 12.9651 5.33334 13.3333C5.33334 13.7015 5.63182 14 6.00001 14H10C10.3682 14 10.6667 13.7015 10.6667 13.3333C10.6667 12.9651 10.3682 12.6667 10 12.6667H8.66668V10.6667C8.66668 10.2985 8.3682 10 8.00001 10Z",
    fill: "#777E91"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.870dadbcb8e3c021318e9b05814cd0d8.svg";
export { ForwardRef as ReactComponent };